// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5c5b0119","45":"e3ef2a24","213":"bb5295b6","356":"57995fb0","453":"513f6c27","455":"5ecf1cae","927":"ab186884"}[chunkId] + ".chunk.js";
};